import { store, connector } from "./store";
import {getPhpFolderPath} from "./query";

export function isConnected(connected, local){
    let isConnected = {
        isConnected: connected,
        local:local
    };
      
    connector.set(isConnected)
}

export function loadData(){
    var xhr = new XMLHttpRequest();
    xhr.open('GET', getPhpFolderPath()+'loadData.php', true);
    xhr.responseType="json"
    xhr.onload = function () {
        store.set(xhr.response);
    };

    xhr.send("");
}

export function SendDataToPhp(url, data, loadType, header = true){
    var httpc = new XMLHttpRequest(); // simplified for clarity
    httpc.open("POST", url, true); // sending as POST
    if(header){
        httpc.setRequestHeader("Content-Type", "application/x-www-form-urlencoded");
    }

    httpc.onreadystatechange = function() { //Call a function when the state changes.
        if(httpc.readyState == 4 && httpc.status == 200) { // complete and no errors
            switch (loadType) {
                case 'protfolio':
                    loadData();
                  break;
                case 'contact':
                    alert("Votre mail à bien été envoyé !");
                  break;
                default:
                    alert("Une erreur est surevnie !");
              }
        }
    };
    httpc.send(data);
}